import { render, staticRenderFns } from "./PointTotals.vue?vue&type=template&id=f6e9eaa2&scoped=true&"
import script from "./PointTotals.vue?vue&type=script&lang=js&"
export * from "./PointTotals.vue?vue&type=script&lang=js&"
import style0 from "./PointTotals.vue?vue&type=style&index=0&id=f6e9eaa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e9eaa2",
  null
  
)

export default component.exports